import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center">
                <i className="ri-grid-line text-primary-700 text-base"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                OOPBuy Spreadsheet
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed mb-4 max-w-xs">
              Der unabhängige deutsche Guide für OOPBuy Spreadsheet. Produktlisten, Anleitungen und Vergleiche einfach erklärt.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4 uppercase tracking-wide">Navigation</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">Startseite</Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">Anleitung</Link>
              </li>
              <li>
                <Link to="/einkaufsfuehrer" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">Einkaufsführer</Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4 uppercase tracking-wide">Kategorien</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More Categories */}
          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4 uppercase tracking-wide">Mehr Kategorien</h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 md:mt-14 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; 2026 OOPBuy Spreadsheet. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">Datenschutz</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">Impressum</a>
          </div>
        </div>
      </div>
    </footer>
  );
}